<div>
  <div class="title">
    <h2 class="primary" i18n="@@Delete Project Folder">Delete Project Folder</h2>
  </div>
  <div>
    <form>
      <app-folder-path [path]="selectedFolder"><ng-container i18n="@@Folder">Folder</ng-container></app-folder-path>
      <p class="deleteFolderPrompt" i18n="@@Confirm the deletion of the folder">Confirm the deletion of the folder</p>
      <div class="folderNotEmpty" *ngIf="!empty" i18n="@@Folder or Subfolders still contain projects. Folder cannot be deleted.">Folder or Subfolders still contain projects. Folder cannot be deleted.</div>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button *ngIf="empty" mat-raised-button type="submit" color="primary" class="Update-btn" (click)="onChange()">{{ 'Delete Folder' | languageString }}</button>
      </div>
    </form>
  </div>
</div>
